import $api from "@/frontend/shared/api/axios";

export async function createStage({ name, prevStageId }: { name: string; prevStageId: number }) {
  return $api.post("/stages", {
    name,
    prevStageId
  });
}
